module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEKADAAQAAAABAAAAEAAAAAA0VXHyAAAAqElEQVQ4EWP8DwQMxIFfQGX7gXgDEF8B4idA/IoBZAAB8BwonwHEfEANmACP5p9AuTog5sLUhSSCw4BnQHEbJGW4mVgMuAQUU8CtA00GzQCQf4nXDDILyQCQn4lzNrIjkAyoQxYnmg01ABRo+EMbl4lQAzJwyRMUBxoA8jv2REJQN1ABUPM2YtThUsMElNiES5IYcZABoIxBNgAZAMpV5ANgGJAXfVArAbOS14Lz4z9DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/otherBubble.png
// module id = NvqK
// module chunks = 1